
import * as Redirect from 'react-router-dom'



function Link(props) {
 return <Redirect.Link
        {...props}>
        {props.children}
      </Redirect.Link>
    }


export default Link;